import { useMemo } from "react"
import type { Direction } from "../../types"

let lastIndex = -1
export const useDirection = (pathname: string, routes: string[]): Direction => {
  if (lastIndex === -1) {
    lastIndex = routes.indexOf(pathname)
  }

  return useMemo(() => {
    const currentIndex = routes.indexOf(pathname)

    let direction: Direction = "none"
    if (currentIndex === -1) {
      return direction
    }

    if (lastIndex > currentIndex) {
      direction = "backward"
    } else if (currentIndex > lastIndex) {
      direction = "forward"
    }

    lastIndex = currentIndex

    return direction
  }, [routes, pathname])
}
